import {stringTool} from '../../../util/string-tool.js';

export default class AddNewStudentController {
  /** @ngInject */
  constructor(
    $rootScope, $log, $mdDialog, $mdToast, moment,
    StudentService,
    GroupService,
    EmployeeService,
    schoolClasses,
    groups,
    currentClassRoom,
    access,
    classRooms
  ) {
    this.$rootScope = $rootScope;
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.moment = moment;
    this.StudentService = StudentService;
    this.GroupService = GroupService;
    this.EmployeeService = EmployeeService;
    this.schoolClasses = schoolClasses;
    this.groups = groups;
    this.currentClassRoom = currentClassRoom;
    this.access = access;
    this.classRooms = classRooms;
    this.StringTool = stringTool;
    this.attendance = {};
    this.students = [];
    this.defaultGroup = this.groups.filter(group => group.default);
    this.date = new Date();
    this.time = moment().format('HH:mm');
    if (this.access.attendance) {
      this.canRegisterToOther = true;
      this.loadEmployees();
    }
  }

  loadUnassignStudents() {
    this.StudentService.getUnlistedStudents({data: this.selectedClass.schoolClassId})
      .then(result => {
        if (result.length === 0) {
          this.$mdToast.show(
            this.$mdToast.simple()
              .textContent('Brak uczniów w oddziale')
              .position('bottom right')
              .hideDelay(3000)
          );
        }

        result.map(student => {
          student.firstNameValue = student.firstName.toLowerCase();
          student.firstNameValue = this.StringTool.escapePolishCharacters(student.firstNameValue);
          student.lastNameValue = student.lastName.toLowerCase();
          student.lastNameValue = this.StringTool.escapePolishCharacters(student.lastNameValue);
          return student;
        });
        this.students.splice(0, this.students.length);
        result.forEach(student => {
          this.students.push(student);
        });
      });
  }

  loadEmployees() {
    this.EmployeeService.getSchoolCommonRoomActiveEmployees(0, true).then(result => {
      result.map(employee => {
        employee.firstNameValue = employee.firstName.toLowerCase();
        employee.firstNameValue = this.StringTool.escapePolishCharacters(employee.firstNameValue);
        employee.lastNameValue = employee.lastName.toLowerCase();
        employee.lastNameValue = this.StringTool.escapePolishCharacters(employee.lastNameValue);
        return employee;
      });
      this.employees = result;
      this.employees.map(employee => {
        if (Number(employee.id) === this.$rootScope.me.employeeId) {
          this.selectedEmployee = employee;
        }

        return employee;
      });
    });
  }

  querySearch(query, arr) {
    return query ? arr.filter(this.createFilterFor(query)) : arr;
  }

  createFilterFor(query) {
    let result = true;
    const lowercaseQuery = query.toLowerCase();
    return item => {
      if (item.lastNameValue.search(lowercaseQuery) === 0) {
        result = (item.lastNameValue.search(lowercaseQuery) === 0);
      } else {
        result = (item.firstNameValue.search(lowercaseQuery) === 0);
      }

      return result;
    };
  }

  register() {
    const registerAttendance = this.createRegister(this.attendance);
    if (registerAttendance.student.studentId) {
      this.addAttendance(registerAttendance);
    } else {
      this.GroupService.addToGroup(this.defaultGroup[0].id, [registerAttendance.student.userId], this.moment(this.date).format('YYYY-MM-DD'))
        .then(result => {
          registerAttendance.student.studentId = result.studentsId[0];
          this.addAttendance(registerAttendance);
        })
        .catch(error => {
          this.$mdDialog.show(
            this.$mdDialog.extendError({
              locals: {error}
            })
          );
        });
    }
  }

  createRegister(attendance) {
    attendance.date = this.moment(this.date).format('YYYY-MM-DD');
    attendance.startTime = this.time;
    return attendance;
  }

  addAttendance(registerAttendance) {
    this.attendance.studentsId = [Number(registerAttendance.student.studentId)];
    this.attendance.classRoomId = this.currentClassRoom.id;
    if (this.selectedClassRoom) {
      this.attendance.classRoomId = this.selectedClassRoom.id;
    }

    if (this.selectedEmployee) {
      this.attendance.employee = this.selectedEmployee.id;
    }

    this.StudentService.addAttendance(this.attendance)
      .then(() => {
        this.$rootScope.$broadcast('controller.new-student.add');
        this.$mdDialog.hide();
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Dodano frekwencję')
            .position('bottom right')
            .hideDelay(3000)
        );
      })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}
